
//这里域名使用配置文件/static/config.js
//声明一个基础接口变量
let imgurl;
//配置开发环境
if (process.env.NODE_ENV === 'development') {
    // imgurl = 'http://www.zhoaoss.com';
    imgurl = window.Glob.DevErpApi;
}
// 配置生产环境
if (process.env.NODE_ENV === 'production') {
  // imgurl = 'https://api.oa.gdzawy.com:9001';
  imgurl = window.Glob.BuildErpApi;
}

//图片接口
// var imgurl = "http://www.zhoaoss.com";
// var imgurl = "http://api.gdzawy.com:9000";
// var imgurl = "http://api.51homemoney.com";

export default imgurl;



// WEBPACK FOOTER //
// ./src/assets/js/imgurl.js